import React, { useContext, lazy, Suspense } from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { Container, LinearProgress } from '@material-ui/core';
import { I18nContext } from 'translations';
const LayoutLanding = lazy(() => import('components/Landing/Layouts'));
const PrivacyEs = lazy(() => import('./Texts/PrivacyEs'));
const PrivacyPt = lazy(() => import('./Texts/PrivacyPt'));

const styles = createStyles(() => ({
  terms: {
    marginTop: '68px',
    padding: '40px 10px',
    textAlign: 'justify'
  }
}));

const Privacy = ({ classes }) => {
  const { langCode } = useContext(I18nContext);
  
  const text = () => {
    switch (langCode) {
      case 'es':
        return <PrivacyEs />
      case 'pt':
        return <PrivacyPt />
      default:
        return <PrivacyEs />
    }
  }

  return (
    <Suspense fallback={<LinearProgress color="primary" />}>
      <LayoutLanding>
        <div className={classes.terms}>
          <Container maxWidth="md">
            {text()}
          </Container>
        </div>
      </LayoutLanding>
    </Suspense>
  )
}

export default withStyles(styles)(Privacy);